import { lazy } from "react";

import { adminPath } from "./constants";
import { SCREEN_IDS } from "../../system/global-enums";

import Performance from "./views/performance/performance";
import BrandReport from "./views/brandReport/brandReport";
import ActivityLogs from "./views/activityLogs/activityLogs";
import Group from "../shared-screens/views/brandGroups";
import UserProfile from "../shared-screens/views/userProfile/userProfile";
import BrandProfile from "../shared-screens/views/brandProfile/brandProfile";
import ThemeSettings from "../shared-screens/views/themeSettings/themeSettings";
import MarketingSales from "../shared-screens/views/marketingSales/marketingSales";
import CampaignMetrics from "../shared-screens/views/campaignMetrics/campaignMetrics";
import UserPermissions from "../shared-screens/views/userPermissions/userPermissions";
import BrandPerformance from "../shared-screens/views/brandPerformance/brandPerformance";
import ConsumerResponses from "../shared-screens/views/consumerResponses/consumerResponses";
import ArchivedQuestions from "../shared-screens/views/archivedQuestions/archivedQuestions";
import BrandConfiguration from "../shared-screens/views/brandConfiguration/brandConfiguration";
import IndividualStoreProfile from "../shared-screens/views/individualStoreProfile/individualStoreProfile";
import IndividualGroupProfile from "../shared-screens/views/individualGroupProfile/individualGroupProfile";
import IndividualStorePerformance from "../shared-screens/views/individualStorePerformance/individualStorePerformance";
import IndividualGroupPerformance from "../shared-screens/views/individualGroupPerformance/individualGroupPerformance";
import MergeDuplicateStores from "./views/mergeDuplicateStores/mergeDuplicateStores";
import FeatureFlag from "./views/featureFlags/featureFlags";
import SurveyQueues from "./views/surveyQueues/surveyQueues";

const Stores = lazy(() => import("./views/stores/stores"));

const AdminRoutes = [
  {
    path: adminPath.STORES,
    name: "stores",
    screenId: SCREEN_IDS.BRANDS,
    component: Stores,
    displayName: "Brands",
    breadcrumb: "Brands",
  },
  {
    path: adminPath.RESTAURANTS_ACTIVITY_LOGS,
    name: "activity-logs",
    screenId: SCREEN_IDS.BRANDS,
    component: ActivityLogs,
    displayName: "Activity Logs",
    breadcrumb: "Activity Logs",
  },
  {
    path: adminPath.MARKETING_SALES,
    name: "marketing-sales",
    screenId: SCREEN_IDS.BRANDS,
    component: MarketingSales,
    displayName: "Marketing Sales",
    breadcrumb: "Marketing Sales",
  },
  {
    path: adminPath.CAMPAIGN_MATRICS,
    name: "campaign-metrics",
    screenId: SCREEN_IDS.BRANDS,
    component: CampaignMetrics,
    displayName: "Campaign Metrics",
    breadcrumb: "Campaign Metrics",
  },
  {
    path: adminPath.RESTAURANTS_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS,
    component: Performance,
    displayName: (
      <>
        <span className="text-gray">Performance</span> - Brand Performance
      </>
    ),
    breadcrumb: "Performance",
  },
  {
    path: adminPath.RESTAURANTS_USER_PERMISSIONS,
    name: "user-permissions",
    screenId: SCREEN_IDS.BRANDS,
    component: UserPermissions,
    displayName: "User Permissions",
    breadcrumb: "Permissions",
    adminOnly: true,
  },
  {
    path: adminPath.RESTAURANTS_BRAND_CONFIGURATION,
    name: "brand-configuration",
    screenId: SCREEN_IDS.BRANDS,
    component: BrandConfiguration,
    displayName: "Brand Configuration",
    breadcrumb: "Brand Configuration",
  },
  {
    path: adminPath.RESTAURANTS_BRAND_PROFILE,
    name: "brand-restaurants",
    screenId: SCREEN_IDS.BRANDS,
    component: BrandProfile,
    displayName: "Brand Stores",
    breadcrumb: "Brand Profile",
  },
  {
    path: adminPath.RESTAURANTS_BRAND_PERFORMANCE,
    name: "brand-performance",
    screenId: SCREEN_IDS.BRANDS,
    component: BrandPerformance,
    displayName: "Brand Performance",
    breadcrumb: "Brand Performance",
  },
  {
    path: adminPath.RESTAURANTS_BRAND_THEME_SETTINGS,
    name: "theme-settings",
    screenId: SCREEN_IDS.BRANDS,
    component: ThemeSettings,
    displayName: "Theme Settings",
    breadcrumb: "Brand Theme Settings",
  },

  // Consumer Responses
  {
    path: adminPath.CONSUMER_RESPONSES_BY_RESTAURANTS,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: adminPath.CONSUMER_RESPONSES_BY_RESTAURANT_BRAND_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: adminPath.CONSUMER_RESPONSES_BY_RESTAURANT_BRAND_GROUPS,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: adminPath.CONSUMER_RESPONSES_BY_RESTAURANT_BRAND_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  // Individual Performance
  {
    path: adminPath.RESTAURANTS_RESTAURANT_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: adminPath.RESTAURANT_PERFORMANCE_BY_BRAND_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: adminPath.RESTAURANT_PERFORMANCE_BY_BRAND_GROUPS,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: adminPath.RESTAURANT_PERFORMANCE_BY_BRAND_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  // Individual Store Profile
  {
    path: adminPath.RESTAURANTS_RESTAURANT_PROFILE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: adminPath.RESTAURANT_PROFILE_BY_BRAND_PROFILE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: adminPath.RESTAURANT_PROFILE_BY_BRAND_GROUPS,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: adminPath.RESTAURANT_PROFILE_BY_BRAND_PERFORMANCE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  // Individual Group Performance
  {
    path: adminPath.GROUP_PROFORMANCE_BY_RESTAURANT_BRAND_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupPerformance,
    displayName: "Group Performance",
    breadcrumb: "Group Performance",
  },
  {
    path: adminPath.GROUP_PROFORMANCE_BY_RESTAURANT_BRAND_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupPerformance,
    displayName: "Group Performance",
    breadcrumb: "Group Performance",
  },
  // Individual Group Profile
  {
    path: adminPath.GROUP_PROFILE_BY_RESTAURANT_BRAND_PROFILE,
    name: "profile",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupProfile,
    displayName: "Group Profile",
    breadcrumb: "Group Profile",
  },
  {
    path: adminPath.GROUP_PROFILE_BY_RESTAURANT_BRAND_PERFORMANCE,
    name: "profile",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupProfile,
    displayName: "Group Profile",
    breadcrumb: "Group Profile",
  },
  {
    path: adminPath.USER_PROFILE,
    name: "userProfile",
    screenId: SCREEN_IDS.BRANDS,
    component: UserProfile,
    displayName: "User Profile",
    breadcrumb: "User Profile",
  },
  {
    path: adminPath.RESTAURANTS_BRAND_GROUPS,
    name: "group",
    screenId: SCREEN_IDS.BRANDS,
    component: Group,
    displayName: "Groups",
    breadcrumb: "Brand Groups",
  },
  {
    path: adminPath.RESTAURANTS_BRAND_ARCHIVED_QUESTIONS,
    name: "archived-questions",
    screenId: SCREEN_IDS.BRANDS,
    component: ArchivedQuestions,
    displayName: "Archived Questions",
    breadcrumb: "Brand Archived Questions",
  },
  {
    path: adminPath.SURVEY_QUEUES,
    name: "survey-queues",
    screenId: SCREEN_IDS.BRANDS,
    component: SurveyQueues,
    displayName: "Survey Queues",
    breadcrumb: "Survey Queues",
    adminOnly: true,
  },
  {
    path: adminPath.MERGE_DUPLICATE_STORES,
    name: "merge-duplicate-stores",
    screenId: SCREEN_IDS.BRANDS,
    component: MergeDuplicateStores,
    displayName: "Merge Duplicate Stores",
    breadcrumb: "Merge Duplicate Stores",
    adminOnly: true,
  },
  {
    path: adminPath.GET_BRAND_REPORT,
    name: "get-brand-report",
    screenId: SCREEN_IDS.BRANDS,
    component: BrandReport,
    displayName: "Brand Report",
    breadcrumb: "Brand Report",
    adminOnly: true,
  },
  {
    path: adminPath.FEATURE_FLAGS,
    name: "feature-flags",
    screenId: SCREEN_IDS.BRANDS,
    component: FeatureFlag,
    displayName: "Feature Flags",
    breadcrumb: "Feature Flags",
    adminOnly: true,
  },
];

export default AdminRoutes;
